import { Badge } from "design-system/atoms/Badge"
import { cn } from "design-system/utils"
import { FlagTriangleRight } from "lucide-react"
import { BackofficeFlagsKindEnum } from "schema"

type FlagKind = (typeof BackofficeFlagsKindEnum)[number]

type Props = {
  flagKey: string
  kind: FlagKind
  count: number
}

export function ConversationFlagKeyBadge({ flagKey, kind, count }: Props) {
  const [namespace, ...keyParts] = flagKey.split(":")
  const bareKey = keyParts.join(":") || namespace

  return (
    <Badge
      variant="outline"
      className={cn("gap-1.5", kind === "Issue" ? "text-testing-2" : "text-negative-soft")}
    >
      {count > 1 && (
        <span className="font-mono tabular-nums">
          {count}
          {"x"}
        </span>
      )}
      <div className="flex items-center gap-0.5">
        <FlagTriangleRight className="size-3" />
        <span className="font-mono">{bareKey}</span>
      </div>
    </Badge>
  )
}
